import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { NoneValue } from '../../..';
export var Headings = /*#__PURE__*/function () {
  function Headings() {
    _classCallCheck(this, Headings);
  }

  _createClass(Headings, null, [{
    key: "sortWithQuestions",
    value: function sortWithQuestions(headings, questions) {
      var _this = this;

      if (!headings || headings.length === 0) {
        return questions;
      }

      var output = [];
      var claimedQuestionIds = new Set();

      var _loop = function _loop(i) {
        var question = questions[i];
        var previousHeading = headings.find(function (h) {
          return h.nextQuestionId === question.id.toString();
        });

        if (previousHeading) {
          return "break";
        }

        var nextHeading = headings.find(function (h) {
          return h.previousQuestionId === question.id.toString();
        });

        if (nextHeading) {
          output.push(question);
          claimedQuestionIds.add(question.id.toString());
          return "break";
        }

        output.push(question);
        claimedQuestionIds.add(question.id.toString());
      };

      for (var i = 0; i < questions.length; i++) {
        var _ret = _loop(i);

        if (_ret === "break") break;
      }

      var _loop2 = function _loop2(_i) {
        var heading = headings[_i];

        if (heading) {
          output.push(heading);

          if (heading.nextQuestionId !== 'none') {
            var startQuestionIndex = questions.findIndex(function (q) {
              return q.id.toString() === heading.nextQuestionId;
            });

            if (startQuestionIndex !== -1) {
              var questionsInHeading = _this.getQuestions(startQuestionIndex, questions, headings).filter(function (q) {
                return !claimedQuestionIds.has(q.id.toString());
              });

              questionsInHeading.forEach(function (q) {
                return claimedQuestionIds.add(q.id.toString());
              });
              output.push.apply(output, _toConsumableArray(questionsInHeading));
            }
          }
        }
      };

      for (var _i = 0; _i < headings.length; _i++) {
        _loop2(_i);
      }

      return output;
    }
  }, {
    key: "getQuestions",
    value: function getQuestions(startIndex, questions, headings) {
      if (questions.length === 0) {
        return [];
      }

      var endIndex = startIndex;

      var _loop3 = function _loop3(i) {
        var questionId = questions[i].id.toString(); // Stop before the first question owned by another heading.
        // Needed when previousQuestionId is missing/"none" (common for AI/created headings).

        if (i > startIndex) {
          var isStartOfAnotherHeading = headings.some(function (h) {
            return h.nextQuestionId === questionId;
          });

          if (isStartOfAnotherHeading) {
            endIndex = i - 1;
            return "break";
          }
        }

        var foundNextHeading = headings.find(function (h) {
          return h.previousQuestionId === questionId;
        });

        if (foundNextHeading) {
          endIndex = i;
          return "break";
        }

        endIndex = i;
      };

      for (var i = startIndex; i < questions.length; i++) {
        var _ret2 = _loop3(i);

        if (_ret2 === "break") break;
      }

      return questions.slice(startIndex, endIndex + 1);
    }
  }, {
    key: "findNextHeadingIdWithPreviousQuestionId",
    value: function findNextHeadingIdWithPreviousQuestionId(headings, questionId) {
      return headings.find(function (h) {
        return h.previousQuestionId === questionId;
      });
    }
  }, {
    key: "findPreviousHeadingWithNextQuestionId",
    value: function findPreviousHeadingWithNextQuestionId(headings, questionId) {
      return headings.find(function (h) {
        return h.nextQuestionId === questionId;
      });
    }
  }, {
    key: "findNearestPreviousQuestionWithItemId",
    value: function findNearestPreviousQuestionWithItemId(itemId, questions, headings) {
      var questionsWithHeadings = Headings.sortWithQuestions(headings, questions);
      var findItemIndex = questionsWithHeadings.findIndex(function (ob) {
        return ob.id.toString() === itemId;
      });

      if (findItemIndex === -1) {
        return null;
      }

      for (var i = findItemIndex - 1; i >= 0; i--) {
        var formItem = questionsWithHeadings[i];

        if (formItem.type !== 'heading') {
          return formItem;
        }
      }

      return null;
    }
  }, {
    key: "findNearestPreviousHeadingWithItemId",
    value: function findNearestPreviousHeadingWithItemId(itemId, questions, headings, isHeadingItem) {
      var foundHeading = isHeadingItem ? headings.find(function (q) {
        return q.id.toString() === itemId;
      }) : questions.find(function (q) {
        return q.id.toString() === itemId;
      });
      if (!foundHeading) return null;
      if (!foundHeading) return null;
      var questionsWithHeadings = Headings.sortWithQuestions(headings.filter(function (h) {
        return h.sectionId === foundHeading.sectionId;
      }), questions.filter(function (q) {
        return q.sectionId === foundHeading.sectionId;
      }));
      var findItemIndex = questionsWithHeadings.findIndex(function (ob) {
        return ob.id.toString() === itemId;
      });

      if (findItemIndex === -1) {
        return null;
      }

      for (var i = findItemIndex - 1; i >= 0; i--) {
        var formItem = questionsWithHeadings[i];

        if (formItem.type === 'heading') {
          return formItem;
        }
      }

      return null;
    }
  }, {
    key: "findNearestNextHeadingWithItemId",
    value: function findNearestNextHeadingWithItemId(itemId, questions, headings, isHeadingItem) {
      var foundHeading = isHeadingItem ? headings.find(function (q) {
        return q.id.toString() === itemId;
      }) : questions.find(function (q) {
        return q.id.toString() === itemId;
      });
      if (!foundHeading) return null;
      var questionsWithHeadings = Headings.sortWithQuestions(headings.filter(function (h) {
        return h.sectionId === foundHeading.sectionId;
      }), questions.filter(function (q) {
        return q.sectionId === foundHeading.sectionId;
      }));
      var findItemIndex = questionsWithHeadings.findIndex(function (ob) {
        return ob.id.toString() === itemId;
      });

      if (findItemIndex === -1) {
        return null;
      }

      for (var i = findItemIndex; i < questionsWithHeadings.length; i++) {
        var formItem = questionsWithHeadings[i];

        if (formItem.type === 'heading' && formItem.id.toString() !== itemId) {
          return formItem;
        }
      }

      return null;
    }
  }, {
    key: "sort",
    value: function sort(headings) {
      var sortedHeadings = [];
      var headOfHeading = headings.find(function (heading) {
        return heading.previousHeadingId === NoneValue;
      });
      if (headOfHeading) sortedHeadings.push(headOfHeading);
      var currentHeadingId = headOfHeading === null || headOfHeading === void 0 ? void 0 : headOfHeading.id.toString();
      headings.forEach(function () {
        var nextHeading = headings.find(function (heading) {
          return heading.previousHeadingId.toString() === currentHeadingId;
        });

        if (!nextHeading) {
          return;
        }

        sortedHeadings.push(nextHeading);
        currentHeadingId = nextHeading.id.toString();
      });
      return sortedHeadings;
    }
  }]);

  return Headings;
}();